<template>
  <div class="dialogImgsPreview">
    <CoverLayout>
      <div class="imgLayout" slot="content">
        <div class="pre" @click="handlePre"></div>
        <div class="imgBox">
          <div class="icon_close" @click="handleClose"></div>
          <img :src="imgs[index]" alt="" />
        </div>
        <div class="next" @click="handleNext"></div>
      </div>
    </CoverLayout>
  </div>
</template>

<script>
import CoverLayout from "./CoverLayout.vue";
export default {
  components: { CoverLayout },
  props: ["imgs"],
  data() {
    return {
      index: 0
    };
  },
  methods: {
    handlePre() {
      this.index = this.index < 1 ? 0 : this.index - 1;
    },
    handleNext() {
      if (this.index + 1 < this.imgs.length) {
        this.index = this.index + 1;
      }
    },
    handleClose() {
      this.$emit("handleClose");
    }
  }
};
</script>

<style scoped lang="scss">
.dialogImgsPreview {
  .imgLayout {
    display: flex;
    align-items: center;
    .pre {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre.png") no-repeat;
      background-size: cover;
      width: 39px;
      height: 80px;
      margin-right: 20px;
      cursor: pointer;
    }
    .next {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre.png") no-repeat;
      background-size: cover;
      width: 39px;
      height: 80px;
      margin-left: 20px;
      transform: rotate(180deg);
      cursor: pointer;
    }
    .imgBox {
      background: #fff;
      // width: 708px;
      position: relative;
      display: flex;
      justify-content: center;
      border-radius: 16px;
      padding: 40px 40px;
      //   box-sizing: border-box;
      img{
          max-width: 800px;
          max-height: 700px;
      }
      .icon_close {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileRemove.png") no-repeat;
        background-size: cover;
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        right: 23px;
        top: 23px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DialogImgsPreview.vue